import { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  FormControl,
  Grid,
  Link,
  Typography,
  IconButton,
  InputLabel,
  LinearProgress,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  Container,
  Breadcrumbs,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
  Pagination,
  AppBar,
  Toolbar,
  InputBase,
  TextField,
  Tooltip,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import axios, { AxiosInstance } from "axios";
import BarChartIcon from "@mui/icons-material/BarChart";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import Cookies from "universal-cookie";
import { urlApi } from "../../parametrage/Pays/RowPays";
import { ConnectedUser } from "../../../../utils/utils";
import { mounthInterface } from "../../../forms/TauxDechange/InterfaceTaux";
import { AlertType, SortType } from "../../../../types/AlertType";
import { DataRef } from "../../../../types/DataRef";
import { SortParams } from "../../production/SaisieAgent";
import CheckAttr from "../../../../utils/CheckAttr";
import { AllMounth } from "../../../../constants/Constants";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { tableStyle } from "../../parametrage/Pays/Pays";
import {
  PrevisionnelInterface,
  tablePrevisionelColumnTittles,
} from "./PrevisionnelQuantiteInterface";
import TabSort from "../../../element/sort/TabSort";
import PrevisionnelQtRow from "./PrevisionnelQtRow";
import AddPrevisionnelQt from "../../../forms/previsionnelQt/AddPrevisionnelQt";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

const PrevisionnelQuantite = () => {
  // Search
  const [paysIdSearch, setPaysIdSearch] = useState<Number>(0);
  const [buIdSearch, setBuIdSearch] = useState<Number>(0);
  const [clientIdSearch, setClientIdSearch] = useState<Number>(0);
  const [operationIdSearch, setOperationIdSearch] = useState<Number>(0);

  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [totalData, setTotalData] = useState<number>(0);
  const [sortedColumn, setSortedColumn] = useState<number>(0);

  const [mounthSelected, setMounthSelected] = useState<mounthInterface>();
  const [yearSelected, setYearSelected] = useState<number>();

  // Data
  const [allPrevisionnel, setAllProvisionnel] = useState<
    PrevisionnelInterface[]
  >([]);

  const [allYear, setAllYear] = useState<number[]>([
    new Date().getFullYear(),
    new Date().getFullYear() + 1,
  ]);

  // Autre
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState<boolean>(false);

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [articleSearch, setArticleSearch] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [dataPays, setDataPays] = useState<DataRef[]>([]);
  const [dataPaysInAssociations, setDataPaysInAssociations] = useState<
    DataRef[]
  >([]);
  const [dataFilteredPays, setDataFilteredPays] = useState<DataRef[]>([]);
  const [dataBusinessUnits, setDataBusinessUnits] = useState<DataRef[]>([]);
  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [dataOperations, setDataOperations] = useState<DataRef[]>([]);

  const [columnToSort, setColumnToSort] = useState<SortParams | undefined>(
    undefined
  );

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
    const dispatch = useDispatch();


   // Add global response interceptor
    http.interceptors.response.use(
        (response) => {
        // Modify response data here, if needed
        return response;
        },
        (error) => {
            console.log(error.message);
            if(error.message ==="Request failed with status code 401"){
                // Remove the redux store
                dispatch(loggoutUser());

                // Remove token in navigator cookies
                cookies.remove('jwt', { path: '/' });

                navigate("/sign-in");
            }
            return Promise.reject(error);
        }
    );

  const user = ConnectedUser();

  //  ############################ Get Search
  const getPaysByPrevision = () => {
    http
      .post("forecast/get/pays/by/model")
      .then((res) => {
        Array.isArray(res.data) && setDataFilteredPays(res.data);
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
    setDataBusinessUnits([]);
    setDataClients([]);
    setDataOperations([]);
    setBuIdSearch(0);
    setClientIdSearch(0);
    setOperationIdSearch(0);
  };

  const getBuByPrevision = (paysIdSearchTemp: Number) => {
    const dataPost = {
      pays: paysIdSearchTemp,
    };
    CheckAttr(paysIdSearchTemp) &&
      http
        .post("forecast/get/bu/by/model/pays", dataPost)
        .then((res) => {
          Array.isArray(res.data) && setDataBusinessUnits(res.data);
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    setDataClients([]);
    setDataOperations([]);
  };

  const getClientByBuPaysPrevision = (buIdSearchTemp: Number) => {
    const dataPost = {
      pays: paysIdSearch,
      bu: buIdSearchTemp,
    };
    http
      .post("forecast/get/client/by/model/pays/bu", dataPost)
      .then((res) => {
        Array.isArray(res.data) && setDataClients(res.data);
        console.log(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
    setDataOperations([]);
  };

  const getOperationByClientBuPaysPrevision = (clientIdSearchTemp: Number) => {
    const dataPost = {
      pays: paysIdSearch,
      bu: buIdSearch,
      client: clientIdSearchTemp,
    };

    CheckAttr(clientIdSearchTemp) &&
      http
        .post("forecast/get/operation/by/model/pays/bu/client", dataPost)
        .then((res) => {
          Array.isArray(res.data) && setDataOperations(res.data);
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  // ######################### Get Data Pour Ajout
  const getPaysPourAjout = () =>{
     // Récupère tous les pays qui existe dans l'association pays-bu
     http.get('pivot-client-bu/get-all-exist-pays-in-association')
     .then(res => {
         Array.isArray(res.data) && setDataPaysInAssociations(res.data);
     }).catch(error => {
         console.log(error);
     });
  }

  // ########################Get Data Table
  const getPrevisionnelSearched = (data: any) => {
    setIsLoading(true);
    http
      .post("forecast/qt/search", data)
      .then((res) => {
        const { total, data } = res.data;
        setTotalData(total);
        Array.isArray(data) && setAllProvisionnel(data);
        console.log(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const reloadList = () => {
    const dataProps = {
      articleSearch: articleSearch,
      rowsPerPage: rowsPerPage,
      page: page,
      filter: {
        pays: paysIdSearch,
        bu: buIdSearch,
        client: clientIdSearch,
        mois: mounthSelected?.id,
        annee: yearSelected,
      },
    };
    getPrevisionnelSearched(dataProps);
  };

  //  ####################### UseEffect

  useEffect(() => {
    // Get Pays Des Budget
    getPaysByPrevision();
    getPaysPourAjout();
  }, []);

  useEffect(() => {
    const dataProps = {
      articleSearch: articleSearch,
      rowsPerPage: rowsPerPage,
      page: page,
      sortby: columnToSort,
      filter: {
        pays: paysIdSearch,
        bu: buIdSearch,
        client: clientIdSearch,
        operation: operationIdSearch,
        mois: mounthSelected?.id,
        annee: yearSelected,
      },
    };
    getPrevisionnelSearched(dataProps);
  }, [
    paysIdSearch,
    buIdSearch,
    clientIdSearch,
    operationIdSearch,
    rowsPerPage,
    page,
    mounthSelected,
    yearSelected,
    columnToSort,
  ]);
  // Handle

  const handleSearch = () => {
    // Recherche par article
    setPage(1);
    setRowsPerPage(5);
    const dataProps = {
      articleSearch: articleSearch,
      // rowsPerPage: 5,
      page: 1,
    };
    getPrevisionnelSearched(dataProps);
    // retrieveData();
  };

  const reloadPage = () => {
    // setRefresh(!refresh);
    window.location.reload();
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const setSortParams = (column: string, order: SortType) => {
    setColumnToSort({
      column,
      orderBy: order,
    });
  };

  // ############## ELEMENT

  const pagination: JSX.Element | boolean = (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowsPerPage}
          onChange={(e) => {
            setPage(1);
            setRowsPerPage(e.target.value as number);
          }}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {!isLoading && totalData > rowsPerPage && (
        <Pagination
          count={Math.ceil(totalData / rowsPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => {
            setPage(value);
          }}
        />
      )}
    </Stack>
  );

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  const iconToUse = (id: number): JSX.Element => {
    let icon = <ArrowUpwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
    if (sortedColumn === id) {
      if (columnToSort && columnToSort.orderBy === "DESC") {
        icon = <ArrowDownwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
      }
    }

    return icon;
  };

  

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#FC8404",
        }}
      >
        <Toolbar disableGutters>
          <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff", ml: 2 }}>
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
              color="inherit"
              href="#"
            >
              <BarChartIcon sx={{ mr: 1 }} fontSize="medium" />
              Prévisionnel
            </Link>
            <Typography sx={{ display: "flex", alignItems: "center" }}>
              <AppRegistrationIcon sx={{ mr: 1 }} fontSize="medium" />
              Quantités
            </Typography>
          </Breadcrumbs>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl">
        <Box sx={{ mt: 4 }}>
          <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
            <Grid item xs={6} sm={2} md={2.25} spacing={1.5}>
              <Tooltip title="Encours de dev">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  color="warning"
                  sx={{ textTransform: "none", marginBottom: { xs: 2 } }}
                  onClick={() => setOpenModal(true)}
                >
                  Ajouter
                </Button>
              </Tooltip>
            </Grid>
            <Grid item xs={2} sm={2} md={1.25}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  color="warning"
                  sx={{ mt: -1 }}
                  shrink={CheckAttr(paysIdSearch) && paysIdSearch !== 0}
                >
                  Pays
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="pays"
                  sx={{ background: "#fff" }}
                  size="small"
                  color="warning"
                  label="Pays"
                  value={paysIdSearch}
                  onChange={(e) => {
                    setPaysIdSearch(e.target.value as Number);
                    setBuIdSearch(0);
                    setClientIdSearch(0);
                    setOperationIdSearch(0);

                    getBuByPrevision(e.target.value as Number);
                  }}
                >
                  <MenuItem value={0}></MenuItem>
                  {dataFilteredPays.map((pays) => (
                    <MenuItem key={pays?.id} value={pays?.id} dense>
                      {pays?.libelle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} sm={2} md={1.25}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  color="warning"
                  sx={{ mt: -1 }}
                  shrink={CheckAttr(buIdSearch) && buIdSearch !== 0}
                >
                  Business unit
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="bu"
                  sx={{ background: "#fff" }}
                  size="small"
                  color="warning"
                  label="Business unit"
                  value={buIdSearch}
                  onChange={(e) => {
                    setBuIdSearch(e.target.value as Number);
                    setClientIdSearch(0);
                    setOperationIdSearch(0);

                    getClientByBuPaysPrevision(e.target.value as Number);
                  }}
                >
                  <MenuItem key={0} value={0}></MenuItem>
                  {dataBusinessUnits.map((bu) => (
                    <MenuItem key={bu?.id} value={bu?.id} dense>
                      {bu?.libelle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} sm={2} md={1.25}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  color="warning"
                  sx={{ mt: -1 }}
                  shrink={CheckAttr(clientIdSearch) && clientIdSearch !== 0}
                >
                  Client
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="client"
                  sx={{ background: "#fff" }}
                  size="small"
                  color="warning"
                  label="Client"
                  value={clientIdSearch}
                  onChange={(e) => {
                    setClientIdSearch(e.target.value as Number);
                    setOperationIdSearch(0);

                    getOperationByClientBuPaysPrevision(
                      e.target.value as Number
                    );
                  }}
                >
                  <MenuItem value={0}></MenuItem>
                  {dataClients.map((client) => (
                    <MenuItem key={client?.id} value={client?.id} dense>
                      {client?.libelle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} sm={2} md={1.25}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  color="warning"
                  sx={{ mt: -1 }}
                  shrink={
                    CheckAttr(operationIdSearch) && operationIdSearch !== 0
                  }
                >
                  Opération
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="operation"
                  sx={{ background: "#fff" }}
                  size="small"
                  color="warning"
                  label="Opération"
                  value={operationIdSearch}
                  onChange={(e) => {
                    setOperationIdSearch(e.target.value as Number);
                  }}
                >
                  <MenuItem value={0}></MenuItem>
                  {dataOperations.map((operation) => (
                    <MenuItem key={operation?.id} value={operation?.id} dense>
                      {operation?.libelle}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={1.5} sm={2} md={1}>
              <FormControl variant="outlined" sx={{ minWidth: 100 }}>
                <InputLabel
                  htmlFor="pays"
                  color="warning"
                  // shrink={CheckAttr(mounthSelected?.id) && mounthSelected?.id !== 0}
                  // shrink={CheckAttr(saisieAgentToSave?.pays)}
                >
                  Mois
                </InputLabel>
                <Select
                  id="Mois"
                  native
                  color="warning"
                  sx={{ background: "#fff" }}
                  size="small"
                  // error={errorInput.paysSelected}
                  value={mounthSelected?.id}
                  onChange={(e) => {
                    setMounthSelected(
                      AllMounth.find((m) => m.id == e.target.value)
                    );
                  }}
                  label="Mois"
                >
                  <option value={0}></option>
                  {AllMounth.map((m) => (
                    <option value={m.id}>{m.mounth}</option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={1.5} sm={2} md={1}>
              <FormControl variant="outlined" sx={{ minWidth: 100 }}>
                <InputLabel
                  htmlFor="pays"
                  color="warning"
                  // shrink={CheckAttr(saisieAgentToSave?.pays)}
                >
                  Année
                </InputLabel>
                <Select
                  id="year"
                  native
                  color="warning"
                  sx={{ background: "#fff" }}
                  size="small"
                  value={yearSelected}
                  onChange={(e) => {
                    setYearSelected(e.target.value as number);
                  }}
                  label="year"
                  inputProps={{
                    name: "year",
                  }}
                >
                  <option value={0}></option>
                  {allYear.map((y) => (
                    <option value={y}>{y}</option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3.5} sm={4} md={2}>
              <Stack
                direction="row"
                spacing={3}
                display="flex"
                ml={3}
                justifyContent="end"
              >
                <InputBase
                  sx={{ color: "white" }}
                  value={articleSearch}
                  placeholder="Article ..."
                  onChange={(e) => setArticleSearch(e.target.value)}
                />
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                  onClick={handleSearch}
                >
                  <SearchIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Stack>
            </Grid>
            <Grid item xs={2} sm={1.5} md={0.5}>
              <IconButton
                aria-label="refresh"
                sx={{ color: "#fff", pt: 0.5 }}
                onClick={() => reloadPage()}
              >
                <RefreshIcon sx={{ fontSize: 35 }} />
              </IconButton>
            </Grid>
          </Grid>
        </Box>

        <Box display="flex" justifyContent="left" mt={4}>
          {pagination}
        </Box>
        <TableContainer component={Paper} style={tableStyle}>
          <Table>
            <TableHead>
              <TableRow>
                {tablePrevisionelColumnTittles.map((column) => (
                  <TabSort
                    key={column.id}
                    column={column}
                    icon={iconToUse(column.id)}
                    sortedColumn={sortedColumn}
                    setSortParams={setSortParams}
                    setSortedColumn={setSortedColumn}
                  />
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <StyledTableCell colSpan={12}>
                  <LinearProgress color="warning" />
                  <Box my={2}>
                    <LinearProgress color="warning" />
                  </Box>
                </StyledTableCell>
              ) : totalData > 0 ? (
                allPrevisionnel.map((prev) => (
                  <PrevisionnelQtRow
                    reloadList={reloadList}
                    previsionnel={prev}
                    http={http}
                    setOpenSnack={setOpenSnack}
                    setAlerteMessage={setAlerteMessage}
                    setAlertType={setAlertType}
                  />
                ))
              ) : (
                <StyledTableCell colSpan={12}>
                  Aucun resultat a été trouvé ...
                </StyledTableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box mt={4} display="flex" justifyContent="right">
          {pagination}
        </Box>
      </Container>
      <OptionalWidthModal
        title="Previsionnel Quantite"
        breackPoint="lg"
        onClose={handleClose}
        open={openModal}
      >
        <AddPrevisionnelQt
          dataPaysInAssociations= {dataPaysInAssociations}
          http={http}
          onClose={handleClose}
          reloadList={reloadList}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          setOpenSnack={setOpenSnack}
        />
      </OptionalWidthModal>
      {stackAlert}
    </>
  );
};

export default PrevisionnelQuantite;
